import React from 'react';
import { useTranslation } from 'react-i18next';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { AddModelButton, DataTable, DeleteModelButton, GetContentButton, Panel, Toolbar } from '@lib/ui-components';
import { useParams } from 'react-router-dom';
import * as Yup from 'yup';

export default function CommuneServiceDeclarations() {
  const [tableReloadKey, setTableReloadKey] = React.useState(1);
  const { t } = useTranslation();
  const pathParams = useParams();
  const projectId = pathParams['projectId']!.substring(1);
  const branchId = pathParams['branchId']!.substring(1);
  return (
    <Panel header={t('communeDeclarations')} borderType='raised'>
      <Toolbar
        right={[
          <AddModelButton
            multipart={true}
            buttonLabel={t('uploadFile')}
            dialogTitle={t('uploadFile')}
            modelName={'communeDeclarationFileViews'}
            fields={[
              { label: t('dragAndDropAFile'), type: 'file', field: 'content' },
              { label: t('comment'), type: 'text', field: 'comment' },
            ]}
            hiddenValues={{
              projectId: projectId,
              companyBranchId: branchId,
            }}
            validationSchema={{
              content: Yup.mixed().required(t('fieldRequired')),
            }}
            onSaved={async () => setTableReloadKey(tableReloadKey + 1)}
          />,
        ]}
      />
      <DataTable
        refreshKey={tableReloadKey}
        fetchPostUrl={'/api/resource/communeDeclarationFileViews/by-params'}
        fetchFilters={{
          projectId: projectId,
          companyBranchId: branchId,
        }}
        initialSort={{ columnIndex: 2, ascending: false }}
        columns={[
          {
            key: 'fileName',
            label: t('file'),
            type: 'text',
          },
          {
            key: 'comment',
            label: t('comment'),
            type: 'text',
          },
          {
            key: 'uploadDate',
            label: t('added'),
            type: 'date',
            dateFormat: 'dd.MM.yyyy HH:mm:ss',
          },
          {
            key: 'uploadBy',
            label: t('addedBy'),
            type: 'text',
          },
        ]}
        rowOptions={[
          {
            renderer: (row) => <GetContentButton label={t('viewFile')} icon={<VisibilityIcon />} resourcePath={`api/resource/communeDeclarationFileViews/${row.id}/content`} />,
          },
          {
            renderer: (row) => <DeleteModelButton modelName={'communeDeclarationFileViews'} id={row.id} onDeleted={async () => setTableReloadKey(tableReloadKey + 1)} />,
          },
        ]}
      />
    </Panel>
  );
}
